import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconShareWebAndroid } from '@redteclab/icons'

import { useOpenableControls } from '../../../../generic-hooks'
import { ProductBuyBoxButton } from '../ProductBuyBoxButton'

import { ProductBuyBoxSocialPopupModal } from './ProductBuyBoxSocialPopupModal'

export const ProductBuyBoxSocialPopup: FC = () => {
  const { handleClose, handleOpen, isOpen } = useOpenableControls(false)

  return (
    <>
      <ProductBuyBoxButton
        onClick={handleOpen}
        startIcon={<IconShareWebAndroid />}
      >
        <FormattedMessage id="general.label.day.share" />
      </ProductBuyBoxButton>
      <ProductBuyBoxSocialPopupModal
        handleClose={handleClose}
        isOpen={isOpen}
      />
    </>
  )
}
